import { flex } from '@byecode/ui'
import styled from 'styled-components'

export const Container = styled.div`
    /* position: relative; */
    /* z-index: 9999999999999999999999; */
`

export const PrimaryContain = styled.div`
    position: relative;
    width: 100%;
    /* background: #ffffff; */
`

export const TargetContainer = styled.div`
    ${flex}
    align-items: center;
`
